<template>
    <ui-sidebar-float
        :load="optionsLoading"
        :load-text="loadText"
        name="new-contract-generation"
        title="Adicionar novo Contrato"
        text="Informe os dados para cadastrar o contrato."
        :overlay-close="false"
    >
        <form :id="formName" class="content">
            <section class="sidebar-content">
                <div v-if="mensage" class="erro-mensage">
                    {{ mensage }}
                </div>

                <ui-input
                    v-model="form.data.name"
                    type="text"
                    :class="form.errors.name"
                    label="Descrição do Contrato:"
                    size="md"
                />

                <div class="select-area">
                    <ui-select-2 
                        v-model="form.data.visibility.products"
                        label="Selecione os Empreendimentos:"
                        :loading="groupFieldLoading"
                        :data="options.products"
                        return-value="value"
                        multiple
                    />
                </div>

                <div class="select-area">
                    <ui-select-2 
                        v-model="form.data.visibility.stage"
                        label="Selecione as Etapas:"
                        :loading="groupFieldLoading"
                        :data="options.stage"
                        return-value="value"
                        group-by="type"
                        item-label="label"
                        multiple
                        @input="stageInputHandler"
                    />
                </div>

                <div class="select-area">
                    <ui-select-2 
                        v-model="form.data.visibility.status"
                        label="Selecione as Status:"
                        :loading="statusLoading"
                        :data="options.status"
                        return-value="value"
                        group-by="type"
                        item-label="label"
                        multiple
                    />
                </div>

                <ui-input
                    v-model="form.data.empty"
                    type="text"
                    :class="form.errors.empty"
                    label="Substituir campos vazios por:"
                    size="md"
                />
            </section>

            <section class="sidebar-content">
                <uiUploadFiles
                    :id="'sidebar-edit-upload' + componentID"
                    :refer="'sidebar-edit-upload' + componentID"
                    :set-docs="form.data.file"
                    label="Anexar Arquivo:"
                    help-text="* Somente arquivos: .doc, .docx"
                    size="md"
                    @change="fileUpload"
                />
            </section>
      
        </form>

        <template #footer>
            <ui-button
                type="button"
                :design="`lg success block`"
                :disabled="!canSubmit"
                @click="submitForm"
            >Salvar Contrato</ui-button
            >
        </template>
    </ui-sidebar-float>
</template>

<script>
import { product, funnel, files, contractGeneration } from "@/services/axios"
import { uiSidebarFloat, uiUploadFiles } from "@/components/ui"
import { uiInput, uiSelect2 } from "@/components/ui/form"
import { uiButton } from "@/components/ui/buttons"

import { sidebarDefaultReset } from './methods'
import { canSubmit } from './computed'

// Queridos colegas de trabalho, apenas editei esse componente, não sintam raiva de mim.

/**
 * Objeto com os dados padrões do formulario 
 * Utilize para limpar o formulario
 */
const defaultFormData = function () {
  return {
    id: null,
    name: "",
    errors: { name: "", products: "", stage: "", status: "", empty: "" },
    data: {
      name: "",
      file_id: 0,
      file: {},
      empty: "",
      permissions: "",
      data: "",
      visibility: {
        products: [],
        stage: [],
        status: [],
      },
    },
    custom_fields: {},
    extra_fields: {
      deal: {
        funnel_stage_id: null,
        funnel_stage_status_id: null,
        product_id: null,
      },
    },
  }
}

const defaultOptionsArray = () => ({
	products: [],
	stage: [],
	status: [],
})

export default {
  components: {
    uiButton,
    uiSidebarFloat,
    uiInput,
    uiUploadFiles,
    uiSelect2,
  },

  data() {
    return {
      formName: 'form-sidebar-' + this._uid,
      componentID: this._uid,
      form: { ...defaultFormData() },
      mensage: "",
      options: { ...defaultOptionsArray() },
      optionsLoading: false,
      productLoading: false,
      stageLoading: false,
      statusLoading: false,
      funnelStageOptions: [],
      funnelStageLoading: false,
      fileUploadLoading: false,
      funnelStageStatusOptions: [],
      funnelStageStatusLoading: false,
      fieldGroupOptions: [],
      fieldGroupSelected: null,
      fieldGroupLoading: false,
      groupFieldOptions: [],
      groupFieldLoading: false,
      groupFieldSelected: null,
      leadOptions: [],
      leadLoading: false,
      unsubscribe: null,
      loadText: null,
    }
  },
  computed: {
    canSubmit
  },
  
  async created() {
    this.$root.$on('sidebar-open-new-contract-generation', async () => {            
      this.clearForm()
      await this.loadForm()
    })
  },

  beforeDestroy() {
    this.$root.$off('sidebar-open-new-contract-generation')
  },
  methods: {
    sidebarDefaultReset,

    /**
     * Faz o uload do arquivo para preparar para o contrato ser criado
     */
    async fileUpload() {
      const element   = document.getElementById('sidebar-edit-upload' + this.componentID)
      const file      = element.files[0]
      const fileData  = new FormData()

      fileData.append('file', file)
      
      await files
        .create('', fileData)
        .then((response) => {
            if (this.form.data.file_id != undefined && response.data[0] != undefined && response.data[0].file != undefined) {
              this.form.data.file_id      = response.data[0].file.id
              let reader = new FileReader()
                    this.form.data.file = {base64: '', name: '', id: ''}
                    reader.addEventListener('load', () => {
                        this.form.data.file['base64'] = reader.result
                    })
                    reader.readAsDataURL(file)
                     this.form.data.file['name'] = file.name
                     this.form.data.file['id'] = 'sidebar-edit-upload' + this.componentID
            }
            this.mensage = ''
            this.$root.$emit('cancel-load-doc', this.form.data.file['id'])
        })
        .catch((error) => {
          this.mensage                = 'O arquivo anexado não é compatível'
          this.productLoading         = false
          console.error(error) 
        })
    },
	
    /**
     * Limpa os dados do formulário e inicializa com os valores padrões
     */
    clearForm() {
      this.form = { ...defaultFormData() }
      this.sidebarDefaultReset()
      this.$root.$emit('clean-file-doc')
    },

    /**
     * Carrega os dados do formulário
     */
    async loadForm() {
      this.optionsLoading = true
      this.loadText = "Carregando"

      await product
          .getProductOptions()
          .then((response) => {
              this.options.products = [...response.data]	
              this.form.data.visibility.products = []
              this.productLoading = false
          })
          .catch((error) => {
            console.error(error)
            this.productLoading = false
          })

      await funnel
          .getStages()
          .then((response) => {
            let stagesList = response.data
            let stageTypedList = []

            stageTypedList = stagesList.map(
              stage => ({ 
                label: stage.name, 
                value: stage.id, 
                type: "Etapas do Sistema"
              })
            )

            this.options.stage = [...stageTypedList] 
            this.form.data.visibility.stage = []
            this.funnelStageOptions = [...stagesList]
            this.stageLoading = false
          })
          .catch((error) => {
              this.stageLoading         = false
              console.error(error)
          })

      setTimeout( ()=> {
          this.optionsLoading         = false
      }, 1200)
    },

    /**
     * Envia os dados do formulário de modo a atualizar a instância
     */
    async submitForm() {
        if (this.canSubmit) {
            this.optionsLoading         = true
            this.loadText               = 'Salvando alterações'
            this.productLoading         = true

            await contractGeneration
            .create("", this.form.data)
            .then(response => {
                if (response.status != "erro") {
                    this.optionsLoading     = false
                    this.productLoading     = false
                } else {
                    console.error(response)
                }
            })
            .catch((error) => {
                console.error(error)
            })
            /* Nivela o tempo do carregamento  */  
            setTimeout( ()=> {  
                this.$root.$emit("datatable-reload-contractGeneration")
                this.$root.$emit("sidebar-close-" + "new-contract-generation")
            }, 1200)
        }
    },
    selectedStagesHaveStatus(){
        let statusSteps = []

        this.form.data.visibility.stage.map((stageId) => {
            const statusList      =   this.loadStageStatusOptions(stageId)
            if (statusList && statusList.length) statusSteps.push(stageId)
        })

      return statusSteps.length > 0
    },

    /**
     * Função retorna o nome da etapa com base no ID dela
     */
    getStageLabel(stageId) {
        const stage = this.options.stage.find(element => element.value == stageId)
        return stage ? stage.label : null
    },
    /**
     * Carrega o select de status de acordo com a etapa selecionada
     */
    loadStageStatusOptions(stageId) {
      const stage = Object.values(this.funnelStageOptions).find(stage => stage.id === parseInt(stageId))
      if (stage) return [...stage.status]
    },

    /**
     * Função chamada quando uma etapa é selecionada
     */
    stageInputHandler() {
        let statusFound = []
        let statusTypedList = []

        if (this.form.data.visibility.stage.length == 0) {
            this.form.data.visibility.status  = []
        } 
        
        /* Gera o grupo dos Status baseados na etapa  */
        this.form.data.visibility.stage.map(stageId => {
            const statusList      =   this.loadStageStatusOptions(stageId)
            const stageLabel      =   this.getStageLabel(stageId)
            let   statusGroup     =   { title: stageLabel, items: [] }

            /* Verifica se a Etapa possui Status */
            if (statusList && statusList.length) {
              statusList.forEach(status => {
                statusGroup.items.push({ 
                  label: status.name, 
                  value: status.id, 
                  type: stageLabel 
                  })
              })
            }

          statusTypedList = [
            ...statusTypedList,
            ...statusGroup.items
          ]
        })
        
        /* Verifica se o stage do status esta selecionado  */  
        this.form.data.visibility.stage.map((stageId) => {
            const statusList      =   this.loadStageStatusOptions(stageId)
            /* Verifica se a Etapa possui Status */
            if (statusList && statusList.length) {
                statusList.map(status => {
                    if (this.form.data.visibility.status.indexOf(status.id) != -1) {
                        statusFound.push(status.id)
                    }
                })
            }
        })
            
        this.form.data.visibility.status = statusFound
        this.options.status = [...statusTypedList]
        this.form.data.visibility.status = []
    },

    /**
     * Carrega select de campos de acordo com o grupo de campos selecionado
     */
    loadGroupFieldOptions(groupId) {
        this.groupFieldLoading = true
        this.groupFieldOptions = []

        const group = Object.values(this.fieldGroupOptions).find(group => group.id === parseInt(groupId))
        if (group) this.groupFieldOptions = [...group.fields]
        this.groupFieldLoading = false
    },
    /**
     * Função chamada quando um grupo de campos é selecionado
     */
    fieldGroupInputHandler(groupId) {
        this.groupFieldSelected = null
        this.loadGroupFieldOptions(groupId)
    }
  },
}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>